import React, { FC } from 'react';

import Collection from '../../../../components/./Collection/Collection';
import CollectionItems from '../../../../components/./Collection/CollectionItems';
import Container from '../../../../components/Container';
import Grid from '../../../../components/Grid';
import HeadingContext from '../../../../components/Heading/HeadingContext';
import EarnedBadgeGrid from '../../../../models/badges/EarnedBadgeGrid';
import { Size } from '../../../../theme/types';

const ImpactBadgesTab: FC = () => {
  return (
    <Container size={Size.Large}>
      <HeadingContext>
        <Collection opts={{ filter: { app: ['both', 'glapp'] } }} resourceType="badges">
          <Grid>
            <CollectionItems<'badges'>>{(item) => <EarnedBadgeGrid item={item} key={item.id} />}</CollectionItems>
          </Grid>
        </Collection>
      </HeadingContext>
    </Container>
  );
};

export default ImpactBadgesTab;
